import { get, post, put } from "../client";
import { SUB_MODELS } from "../routes";

export default {
  get: async (data) => await get(SUB_MODELS, data),

  create: async (data) => await post(SUB_MODELS, data),
};
